"use client";
import { u as n } from "./useIsoLayoutEffect-DpJo20by.mjs";
import { a as r } from "./useRenderElement-B8V3_e8R.mjs";
function u(e) {
  const t = r(s, e).current;
  return t.next = e, n(t.effect), t;
}
function s(e) {
  const t = {
    current: e,
    next: e,
    effect: () => {
      t.current = t.next;
    }
  };
  return t;
}
export {
  u
};
